import { render, staticRenderFns } from "./ConfirmMessage.vue?vue&type=template&id=ac86f076"
import script from "./ConfirmMessage.vue?vue&type=script&lang=js"
export * from "./ConfirmMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports